<template>
  <v-col>
    <v-simple-table>
      <tbody>
        <template v-for="(item, indexItem) in items">
        <tr :key="`${indexItem}-title`">
          <td style="top: 0;" colspan="10" class="floatingtd"><h1>{{ item.title }}</h1></td>
        </tr>
        <tr :key="`${indexItem}-dates`">
          <td></td>
          <td :style="moment.utc(date).local().format('DD') % 2 === 0 ? 'background-color: #e0e0e0;' : ''" style="white-space: nowrap;" v-for="date in dates" :key="`${indexItem}-${date}`">
            <b>{{ moment.utc(date).local().format('DD/MM') }}</b> {{ moment.utc(date).local().format('HH') }}h
          </td>
        </tr>
         <template v-for="(model, indexModel) in models">
          <tr :key="`${indexItem}-${indexModel}`">
            <td class="floatingtd">{{ model }}</td>
            <td v-for="date in dates" :key="`${indexItem}-${indexModel}-${date}`" align="center" :style="{ 'background-color': getColor(item.field, item.format(getValueForDateModel(date, model, item.field))) }">
              <template v-if="getValueForDateModel(date, model, item.field) === null">
              -
              </template>
              <template v-else>
              {{ item.format(getValueForDateModel(date, model, item.field)) }}
              </template>
            </td>
          </tr>
          </template>
        </template>
      </tbody>
    </v-simple-table>
  </v-col>
</template>

<script>
import api from '@/api';
import moment from 'moment';
import { iconUrl } from '../../iconUrl';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      moment: moment,
      alerts: [],
      dates: [],
      datas: [],
      models: [],
      items: [
        {
          title: 'temp (°C)',
          field: 'tmax',
          format: (value) => Math.round(value * 10) / 10
        },
        {
          title: 'vents (km/h)',
          field: 'wind_speed',
          format: (value) => Math.round(value * 3.6)
        },
        {
          title: 'rafales (km/h)',
          field: 'gustsfc',
          format: (value) => Math.round(value * 3.6)
        },
        {
          title: 'pluie (mm/h)',
          field: 'apcpsfc',
          format: (value) => Math.round(value * 100) / 100
        }
      ],
    };
  },
  computed: {
    ...mapState(['user']),
    thresholds() {
      return {
        tempMax: this.alerts['temp-max'] ? Math.max(...this.alerts['temp-max'].map((alert) => alert.number)) : null,
        tempMin: this.alerts['temp-min'] ? Math.min(...this.alerts['temp-min'].map((alert) => alert.number)) : null,
        wind: this.alerts['wind'] ? Math.max(...this.alerts['wind'].map((alert) => alert.number)) : null,
        rain: this.alerts['rain-max'] ? Math.max(...this.alerts['rain-max'].map((alert) => alert.number)) : null,
      };
    },
  },
  methods: {
    iconUrl,
    getValueForDateModel(date, model, param) {
      let findModel = this.datas.find((map) => map.model == model);
      let findData = findModel.data.find((map) => map.date == date);
      return findData ? (findData[param] ? findData[param] : null) : null;
    },
    getMulti() {
      api.forecast.getMulti(this.$route.params.geoname).then((res) => {
        this.datas = res;
        res.forEach((element) => {
          this.models.push(element.model);
          element.data.map((map) => this.dates.push(map.date));
        });
        let dates = [...new Set(this.dates)];
        this.dates = dates.sort(function (a, b) {
           var dateA = new Date(a);
            var dateB = new Date(b);
            return dateA - dateB;
        });
      });
    },
    async getAlerts() {
      return (await api.alert.getMapAlerts(this.user.id_user))
        .filter((alert) => alert.geoname === this.$route.params.geoname)
        .map((alert) => alert.config)
        .flat()
        // Group by key
        .reduce((alerts, alert) => {
          alerts[alert.key] = alerts[alert.key] ?? [];
          alert.number = Number(alert.number);
          alerts[alert.key].push(alert);
          return alerts;
        }, {});
    },
    getColor(field, value) {
      const baseColor = 'white';
      let color;

      if (field === 'tmax') {
        const delta = this.thresholds.tempMax !== null && value > this.thresholds.tempMax
          ? value - this.thresholds.tempMax
          : this.thresholds.tempMin !== null
            ? this.thresholds.tempMin - value
            : 0;

          color = delta > 3
            ? 'red'
            : delta > 1
              ? 'orange'
              : delta > 0
                ? 'yellow'
                : baseColor;
      }
      else if (field === 'wind_speed' || field === 'gustsfc') {
          const delta = this.thresholds.wind !== null
            ? value - this.thresholds.wind
            : 0;

          color = delta > 10
            ? 'red'
            : delta > 5
              ? 'orange'
              : delta > 0
                ? 'yellow'
                : baseColor;
      }
      else if (field === 'apcpsfc') {
          const delta = this.thresholds.rain !== null
            ? value - this.thresholds.rain
            : 0;

          color = delta > 7.5
            ? '#4169E1'
            : delta > 2.5
              ? '#1E90FF'
              : delta > 0.1
                ? '#ADD8E6'
                : delta > 0
                  ? '#B0C4DE'
                  : baseColor;
      }
      else {
        color = baseColor;
      }

      return color;
    }
  },
  async mounted() {
    this.getMulti();
    this.alerts = await this.getAlerts();
  },
};
</script>

<style>
td.floatingtd {
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  top: 23px;
  background-color: white;
  z-index: 3;
}
</style>